import React from "react"
import MetaTags from "../src/MetaTags"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import LayoutFirebase from "../src/LayoutFirebase"
import { getPage } from "../lib/contentful-api"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

const Index = ({ page }) => {
  const { t } = useTranslation()
  const { title, content } = page

  return (
    <>
      <MetaTags
        title={title}
        description="Our privacy policies."
      />
      <LayoutFirebase>
        <div className="max-w-4xl mx-auto">
          <h1 className="sm:text-5xl text-4xl text-center font-medium my-8 text-gray-700">
            {title}
          </h1>
          <div className="my-12 mx-4" className="markdown">{documentToReactComponents(content.json)}</div>
        </div>
      </LayoutFirebase>
    </>
  )
}
export default Index

export const getStaticProps = async ({ locale }) => {
  const data = await getPage("privacy")

  return {
    props: {
      ...(await serverSideTranslations(locale)),
      page: data.page,
    },
    revalidate: 1,
  }
}
